import React from "react";
import { CRMIcon, TIconSizes } from "../CRMIcon/CRMIcon";
import { TButtonIcon } from "../../models/TButton";
import { CRMColors } from "../../models/CRMColors";
import { THexColor } from "../../models/StringLiterals";

type TCRMButtonFlatColorIconProps =
    TButtonIcon &
    {
        backgroundColor: THexColor;
        iconColor?: THexColor;
        size?: TIconSizes;
        isRounded?: boolean;
        disabled?: boolean;
        loading?: boolean;
    }
;

export const CRMButtonFlatColourIcon = (props: TCRMButtonFlatColorIconProps): JSX.Element => {

    const isDisabled = props.disabled || props.loading;

    const getIconColor = (): THexColor =>
        isDisabled ?
            CRMColors.NEUTRAL_2
            : props.iconColor || CRMColors.NEUTRAL_INK
    ;

    return (
        <div
            title={props.title}
            style={{
                backgroundColor: isDisabled && !props.loading ? CRMColors.NEUTRAL_12 : props.backgroundColor,
                color: props.iconColor || CRMColors.NEUTRAL_INK,
            }}
            className={`
                crm-button-flat-colour-icon
                crm-button-flat-colour-icon--size-${props.size || "medium"}
                crm-button-flat-colour-icon--${isDisabled ?  "disabled" : "enabled" }
                crm-button-flat-colour-icon--${props.isRounded ?  "rounded" : "angled" }
            `}
            onClick={!isDisabled ? props.onClick : undefined}
        >
            {props.loading ? (
                <div className="crm-button-flat-colour-icon__spinner" aria-label="Loading" />
            ) : (
                <CRMIcon
                    iconName={props.icon}
                    size={props.size || "medium"}
                    colour="hex"
                    hexColour={getIconColor()}
                />
            )}
        </div>
    );
}
